export * from './lib/shared-dialog.module';
export * from './lib/dialog/models/confirmation-dialog-payload';
export * from './lib/dialog/components/dialog-base/dialog-base.component';
export * from './lib/dialog/components/confirmation-dialog/confirmation-dialog.component';
export * from './lib/state/state.interface';
export * from './lib/state/actions/dialog-actions';
export * from './lib/dialog/services/modal-dialog/modal-dialog.service';
export * from './lib/dialog/services/component-registration/component-registration.service';
